// src/app/state/cart.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadPaintersSuccess, loadPainters } from './painters.actions';
import { IPainters } from '@interfaces';
//import { PainterService } from '../services/painter.service';

@Injectable()
export class PainterEffects {
  //   loadPainters$ = createEffect(() =>
  //     this.actions$.pipe(
  //       ofType(loadPainters),
  //       mergeMap(() =>
  //         this.painterService.getPainters().pipe(
  //           map((painters: IPainters[]) => loadPaintersSuccess({ painters })),
  //           catchError(() => of({ type: '[Cart] Load Painters Failed' }))
  //         )
  //       )
  //     )
  //   );

  constructor(
    private actions$: Actions,
    //private painterService: PainterService
  ) {}
}
